/* tslint:disable */
/* eslint-disable */
/**
 * API Gateway
 * This API provides user authentication and profile management.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
/**
 *
 * @export
 * @interface V1CoachSettings
 */
export interface V1CoachSettings {
    /**
     *
     */
    coachId: string
    /**
     *
     */
    enabled: boolean
    /**
     *
     */
    autoAccept: boolean
    /**
     *
     */
    languages?: Array<string>
    /**
     *
     */
    price?: number
    /**
     *
     */
    aiPersona?: string
    /**
     *
     */
    aiWorkoutInstructions?: string
}

/**
 * Check if a given object implements the V1CoachSettings interface.
 */
export function instanceOfV1CoachSettings(
    value: object
): value is V1CoachSettings {
    if (!('coachId' in value) || value['coachId'] === undefined) return false
    if (!('enabled' in value) || value['enabled'] === undefined) return false
    if (!('autoAccept' in value) || value['autoAccept'] === undefined)
        return false
    return true
}

export function V1CoachSettingsFromJSON(json: any): V1CoachSettings {
    return V1CoachSettingsFromJSONTyped(json, false)
}

export function V1CoachSettingsFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean
): V1CoachSettings {
    if (json == null) {
        return json
    }
    return {
        coachId: json['coachId'],
        enabled: json['enabled'],
        autoAccept: json['autoAccept'],
        languages: json['languages'] == null ? undefined : json['languages'],
        price: json['price'] == null ? undefined : json['price'],
        aiPersona: json['aiPersona'] == null ? undefined : json['aiPersona'],
        aiWorkoutInstructions:
            json['aiWorkoutInstructions'] == null
                ? undefined
                : json['aiWorkoutInstructions']
    }
}

export function V1CoachSettingsToJSON(json: any): V1CoachSettings {
    return V1CoachSettingsToJSONTyped(json, false)
}

export function V1CoachSettingsToJSONTyped(
    value?: V1CoachSettings | null,
    ignoreDiscriminator: boolean = false
): any {
    if (value == null) {
        return value
    }

    return {
        coachId: value['coachId'],
        enabled: value['enabled'],
        autoAccept: value['autoAccept'],
        languages: value['languages'],
        price: value['price'],
        aiPersona: value['aiPersona'],
        aiWorkoutInstructions: value['aiWorkoutInstructions']
    }
}
